// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"src-components-Breadcrumbs-Breadcrumbs_breadcrumbs--1HSQdJH6","item":"src-components-Breadcrumbs-Breadcrumbs_item--IDPmtlRG"};